import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'loading-overlay',
    template: `
        <div class="loading-overlay" [class.active]="isLoading" *ngIf="isLoading">
            <div class="loading-backdrop"></div>
            <div class="loading-container">
                <div class="loading-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                </div>
                <div class="loading-text">Loading...</div>
                <div class="loading-count" *ngIf="loadingCount > 1">
                    {{ loadingCount }} operations in progress
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./loading-overlay.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class LoadingOverlayComponent implements OnInit, OnDestroy {
    public isLoading: boolean = false;
    public loadingCount: number = 0;
    
    private loadingSubscription?: Subscription;
    private countSubscription?: Subscription;

    constructor(private loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingSubscription = this.loadingService.loading$.subscribe(
            (loading: boolean) => this.isLoading = loading
        );
        
        this.countSubscription = this.loadingService.loadingCount$.subscribe(
            (count: number) => this.loadingCount = count
        );
    }

    ngOnDestroy(): void {
        if (this.loadingSubscription) {
            this.loadingSubscription.unsubscribe();
        }
        if (this.countSubscription) {
            this.countSubscription.unsubscribe();
        }
    }
}